require('./style.less');

var Modal = require('../../common/modal/modal'),
    _ = require('underscore'),
    ChildPgInfoView = require('./pageInfoDetail/pgInfoDetail');

//TODO: incorp concept of child template in the main class (and apply to other uses)


var defaults =  {
    hideFooter: true,
    omitBodyOverflow: true,
    // Note: for now setting height to a fixed value that would fix the height of content column one & one row of redactions for 1 page;
    // This could/should be made more dynamic in the future to fit the height of the contents (DVBC-1508)
    height: '350px', // was 325: added more spacing with addition of another line for full page reason codes; not making dynamic for now; looks ok
    omitBodyPadding: true,
    width: '600px' //TODO: autosize, etc
};


module.exports = Modal.extend({
    compositeTemplate: require('./template.hbs'),
    initialize: function(options) {

        var pgs = this.options.pages,
            isSinglePg = pgs instanceof Backbone.Model,
            $compositeMarkup = $( this.compositeTemplate() ),
            childPgs =  isSinglePg ? [this.options.pages] : this.options.pages.models;

        _.each(childPgs, function(pg) {
            $compositeMarkup.find('.pg-info-tbl-wr').append(  new ChildPgInfoView({
                model: pg,
                activeDocId: this.options.activeDocId
            }).render().el );
        }, this);

        this.settings = _.extend( {} , {
            content: $compositeMarkup[0].outerHTML
        }, defaults, options );

        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.defaults ) );
        return this;
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/pageinfo/view.js
 ** module id = 145
 ** module chunks = 0
 **/